import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { Observable } from 'rxjs';

export type MovePurchaseOrderLineBody =
  | { target_purchase_order_id: number }
  | {
      create_dummy_purchase_order: true;
      hub_id: number;
      relation_id: number;
      date?: string;
    };

export interface MovePurchaseOrderLineResponse {
  data: {
    id: number;
    purchase_order_id: number;
  };
  warnings?: string[];
}

export interface PurchaseOrderLineAlreadyInvoicedPayload {
  message: string;
  error_code: 'purchase_order_line_already_invoiced';
  purchase_invoice?: {
    id: number;
    invoice_number?: string;
    is_draft?: boolean;
  };
  purchase_invoice_line?: {
    id: number;
    purchase_invoice_id: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderLineService extends BaseService<unknown> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/purchase_order_lines';
  }

  public move(
    purchaseOrderLineId: number,
    body: MovePurchaseOrderLineBody
  ): Observable<MovePurchaseOrderLineResponse> {
    return this._http.post<MovePurchaseOrderLineResponse>(
      this.getUrl(`${this.path}/${purchaseOrderLineId}/move`),
      body
    );
  }
}

